// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import { Link } from "react-router-dom";
import ContactBand from "../ContactBand";

export default function ServiceAiPage() {
  return (
    <main>
      <section className="page-hero svc-hero ground" data-en="SERVICE">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">トップ</Link>
            <Link to="/services">サービス</Link>
            <span>AIインテグレーション</span>
          </nav>
          <div className="svc-hero-grid">
            <div>
              <p className="svc-label">Service 01</p>
              <h1 className="svc-title">AIインテグレーション</h1>
              <p className="svc-catch">
                既存の業務にAIエージェントを組み込み、業務改革から、それを支える基盤づくりまでを開発します。
              </p>
              <p className="svc-short">
                「AIを導入したいが、どの業務から手をつければよいか分からない」という段階からご相談いただけます。
              </p>
              <div className="hero-cta svc-hero-cta">
                <Link className="btn" to="/consult">
                  <img src="/assets/icn_paperplane.svg" alt="" />
                  AI導入の無料相談
                </Link>
                <Link className="btn btn-sub" to="/document">
                  資料ダウンロード
                </Link>
              </div>
            </div>
            <div className="svc-img">
              <img
                className="svc-main-img"
                src="/assets/images/services/ai-integration-main-v5a.jpg"
                alt="ビジネスパーソンの横顔に業務のデータやワークフローが重なるイメージ"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="section svc-value">
        <div className="container">
          <h2 className="value-title">AIエージェントを、チームの一員に。</h2>
          <p className="value-text">
            業務の流れを整理し、効果の出やすい業務を見極めたうえで、AIエージェントを設計・開発します。データ基盤の整備や社内への定着まで支援し、最終的には社内のチームが自らAIエージェントを使いこなし、改善を回し続けられる状態をつくります。
          </p>
          <ul className="value-list">
            <li>定型業務をAIエージェントに任せ、人は判断と創造に集中できる</li>
            <li>社内のデータと知見を、誰でもすぐに引き出せる状態になる</li>
            <li>試して終わりではなく、現場で使われ続ける仕組みになる</li>
          </ul>
        </div>
      </section>
      <section className="section ground svc-issue">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            こんなお悩みはありませんか<strong>Issues</strong>
          </h2>
          <ul className="issue-list">
            <li className="issue-card">
              <span className="issue-mark">?</span>
              <p>
                AIを導入したいが、
                <br />
                何から始めればいいか分からない
              </p>
            </li>
            <li className="issue-card">
              <span className="issue-mark">?</span>
              <p>
                生成AIを試したが、
                <br />
                業務の成果につながっていない
              </p>
            </li>
            <li className="issue-card">
              <span className="issue-mark">?</span>
              <p>
                使える人と使えない人の差が大きく、
                <br />
                組織として活用できていない
              </p>
            </li>
          </ul>
          <p className="issue-answer">
            その悩み、LEAPS が<strong>組織でAIを使いこなせる状態まで</strong>
            伴走します。
          </p>
        </div>
      </section>
      <section className="section svc-feat">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            このサービスの特徴<strong>Feature</strong>
          </h2>
          <div className="feat-rows">
            <div className="feat-row">
              <div className="feat-copy">
                <span className="feat-num">01</span>
                <h3>業務への組み込み</h3>
                <p>
                  既存の業務フローを整理し、効果の出やすい業務を見極めたうえで、AIエージェントを現場の仕事に組み込みます。
                </p>
              </div>
              <div className="feat-img">
                <div className="dg dg-ba">
                  <p className="dg-tag">いまの業務</p>
                  <div className="dg-row">
                    <span className="dg-box">受付</span>
                    <i className="dg-ar">→</i>
                    <span className="dg-box">確認・整理</span>
                    <i className="dg-ar">→</i>
                    <span className="dg-box">回答作成</span>
                    <i className="dg-ar">→</i>
                    <span className="dg-box">送信</span>
                  </div>
                  <p className="dg-down">↓</p>
                  <p className="dg-tag dg-tag-l">AIを組み込んだ業務</p>
                  <div className="dg-row">
                    <span className="dg-box">受付</span>
                    <i className="dg-ar">→</i>
                    <span className="dg-box">確認・整理</span>
                    <i className="dg-ar">→</i>
                    <span className="dg-box dg-l">
                      AIエージェント<small>回答の下書き</small>
                    </span>
                    <i className="dg-ar">→</i>
                    <span className="dg-box">送信</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="feat-row rev">
              <div className="feat-copy">
                <span className="feat-num">02</span>
                <h3>AIエージェント開発</h3>
                <p>
                  業務やデータに合わせたAIエージェントを、設計から開発まで手がけます。既存のシステムとの連携にも対応します。
                </p>
              </div>
              <div className="feat-img">
                <div className="dg dg-merge">
                  <div className="dg-col">
                    <span className="dg-box">社内のデータ</span>
                    <span className="dg-box">業務のナレッジ</span>
                    <span className="dg-box">既存のツール</span>
                  </div>
                  <i className="dg-ar dg-ar-lg">→</i>
                  <div className="dg-hub dg-l">
                    <b>AIエージェント</b>
                    <small>業務に合わせて設計・開発</small>
                  </div>
                  <i className="dg-ar dg-ar-lg">→</i>
                  <div className="dg-col">
                    <span className="dg-box dg-out">
                      誰が使っても
                      <br />
                      同じ品質
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="feat-row">
              <div className="feat-copy">
                <span className="feat-num">03</span>
                <h3>基盤づくりと定着</h3>
                <p>
                  データ基盤の整備から、社内で使い続けられる運用ルールづくり、利用の定着まで支えます。
                </p>
              </div>
              <div className="feat-img">
                <div className="dg dg-stairs">
                  <div className="dg-stair dg-s1">
                    <b>導入期</b>
                    <small>ツールを使える</small>
                  </div>
                  <div className="dg-stair dg-s2">
                    <b>個人活用期</b>
                    <small>人によって使い方が違う</small>
                  </div>
                  <div className="dg-stair dg-s3 dg-l">
                    <b>組織活用期</b>
                    <small>基盤があり、誰でも使える</small>
                  </div>
                  <div className="dg-stair dg-s4 dg-l">
                    <b>定着期</b>
                    <small>業務の中で自走している</small>
                  </div>
                  <p className="dg-stair-note">
                    LEAPS は「組織活用期」から先までを伴走
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="mid-cta">
            <p>
              打ち合わせでは、進め方や類似の事例をご紹介します。
              <br />
              お気軽にご相談ください。
            </p>
            <div className="hero-cta">
              <Link className="btn" to="/consult">
                <img src="/assets/icn_paperplane.svg" alt="" />
                AI導入の無料相談
              </Link>
              <Link className="btn btn-sub" to="/document">
                資料ダウンロード
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className="section ground flow">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            支援の流れ<strong>Flow</strong>
          </h2>
          <ol className="flow-list flow-icons">
            <li>
              <span className="flow-num">01</span>
              <span className="flow-icon">1</span>
              <h3>ご相談・課題整理</h3>
              <ul>
                <li>現状と目標のヒアリング</li>
                <li>取り組む課題の整理</li>
              </ul>
            </li>
            <li>
              <span className="flow-num">02</span>
              <span className="flow-icon">2</span>
              <h3>企画・設計</h3>
              <ul>
                <li>技術と進め方の選定</li>
                <li>企画・設計の作成</li>
              </ul>
            </li>
            <li>
              <span className="flow-num">03</span>
              <span className="flow-icon">3</span>
              <h3>開発・実装</h3>
              <ul>
                <li>プロダクトの開発</li>
                <li>テスト・リリース</li>
              </ul>
            </li>
            <li>
              <span className="flow-num">04</span>
              <span className="flow-icon">4</span>
              <h3>定着・グロース</h3>
              <ul>
                <li>運用・改善</li>
                <li>定着と事業成長の支援</li>
              </ul>
            </li>
          </ol>
        </div>
      </section>
      <section className="section svc-proof">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            関連する記事<strong>Media</strong>
          </h2>
          <div className="media-grid">
            <a
              className="media-card"
              href="https://leaps-inc.com/media/dpp-apparel-deadline/"
            >
              <img
                className="media-thumb"
                src="https://leaps-inc.com/cms-admin/wp-content/uploads/2026/09/dpp-apparel-deadline-768x432.png"
                alt="「DPPは2029年から」ではありません ― 欧州向けアパレルの実際の期限"
              />
              <div className="media-body">
                <div className="media-meta">
                  <time className="date" dateTime="2026-09-30">
                    2026.09.30
                  </time>
                  <span className="media-tag">EU規制</span>
                </div>
                <h3>
                  「DPPは2029年から」ではありません ―
                  欧州向けアパレルの実際の期限
                </h3>
                <p>
                  EUのデジタル製品パスポート（DPP）は繊維製品で2029年ごろの適用見込みですが、生産計画から逆算すると準備開始は2027年。先に始まる強制労働規則・繊維EPRとあわせて、実際の期限を整理します。
                </p>
              </div>
            </a>
            <a
              className="media-card"
              href="https://leaps-inc.com/media/ai-case-studies/"
            >
              <img
                className="media-thumb"
                src="https://leaps-inc.com/cms-admin/wp-content/uploads/2026/09/ai-case-studies-768x432.png"
                alt="国内外34のAI活用事例を業務別に整理｜効果が出た仕事の共通点"
              />
              <div className="media-body">
                <div className="media-meta">
                  <time className="date" dateTime="2026-09-28">
                    2026.09.28
                  </time>
                  <span className="media-tag">業務別活用</span>
                </div>
                <h3>
                  国内外34のAI活用事例を業務別に整理｜効果が出た仕事の共通点
                </h3>
                <p>
                  国内外のAI導入事例34件を、会社の発表や国の資料までさかのぼって集めました。自社のどの仕事に使えるかを探せる業務別の早見表と、従業員30〜100名ほどの中小企業が実際に何をしたか、最初の一歩の試し方をまとめます。
                </p>
              </div>
            </a>
            <a
              className="media-card"
              href="https://leaps-inc.com/media/ai-budget-approval/"
            >
              <img
                className="media-thumb"
                src="https://leaps-inc.com/cms-admin/wp-content/uploads/2026/09/ai-budget-approval-768x432.png"
                alt="AI導入の稟議を通すために用意した資料の中身"
              />
              <div className="media-body">
                <div className="media-meta">
                  <time className="date" dateTime="2026-09-01">
                    2026.09.01
                  </time>
                  <span className="media-tag">費用・ベンダー選定</span>
                </div>
                <h3>AI導入の稟議を通すために用意した資料の中身</h3>
                <p>
                  「効果が読めない」で止まる稟議に対して、実際に通った資料がどう構成されていたかを公開します。
                </p>
              </div>
            </a>
          </div>
          <div className="more">
            <a href="https://leaps-inc.com/media/">
              LEAPS AI Media の記事をすべて見る →
            </a>
          </div>
        </div>
      </section>
      <ContactBand />
    </main>
  );
}
